import PaymentResult from "../../components/Payment/PaymentResult/PaymentResult";

const StatusError = () => {
    return <PaymentResult response="error" />;
};

export default StatusError;
